/*
  A/B test: PDP "Main image + thumbnails" gallery (snippets/hero-product-gallery-thumbnails.liquid).

  Does not create its own Swiper: it attaches to the instance bundle.product.js creates on
  .js-gallery-swiper (< 1280px; destroyed and recreated when crossing the breakpoint).
  Slide order/visibility is owned by the variant filter scripts, so thumbnails mirror the
  slides' DOM order and hidden state via a MutationObserver.
*/
(function () {
  function isSlideHidden(slide) {
    if (!slide) return true;
    if (slide.classList.contains('!hidden') || slide.classList.contains('swiper-slide-hidden')) return true;
    return slide.style.display === 'none';
  }

  function initGallery(root) {
    if (root.dataset.thumbsInit === 'true') return;

    var swiperEl = root.querySelector('.js-gallery-swiper');
    var mediaList = root.querySelector('.product__media-list');
    var strip = root.querySelector('[data-gallery-thumbs]');
    if (!swiperEl || !mediaList || !strip) return;

    root.dataset.thumbsInit = 'true';

    var thumbsByKey = {};
    strip.querySelectorAll('[data-thumb-key]').forEach(function (thumb) {
      thumbsByKey[thumb.dataset.thumbKey] = thumb;
    });

    var boundSwiper = null;
    var syncRaf = null;
    var lastActiveKey = null;
    var forceStripScroll = false;

    function getSwiper() {
      var swiper = swiperEl.swiper;
      return swiper && !swiper.destroyed ? swiper : null;
    }

    function getSlides() {
      return Array.prototype.slice.call(mediaList.querySelectorAll('.product__media-item'));
    }

    function getSlideIndex(swiper, slide) {
      var index = Array.prototype.indexOf.call(swiper.slides, slide);
      if (index === -1) index = getSlides().indexOf(slide);
      return index;
    }

    function getActiveSlide(slides) {
      var swiper = getSwiper();
      var active = null;
      if (swiper && swiper.slides) {
        active = swiper.slides[swiper.activeIndex];
      } else {
        // Pre-init native scroll: derive the active slide from the scroll position.
        var width = swiperEl.clientWidth || 1;
        active = slides[Math.round(swiperEl.scrollLeft / width)];
      }
      if (active && !isSlideHidden(active)) return active;
      for (var i = 0; i < slides.length; i++) {
        if (!isSlideHidden(slides[i])) return slides[i];
      }
      return null;
    }

    // ILIA-style: the active thumbnail becomes the first visible one, previous thumbnails
    // move out of view to the left. Near the end the strip clamps at its max scroll.
    function scrollThumbToStart(thumb, smooth) {
      var maxScroll = strip.scrollWidth - strip.clientWidth;
      var target = Math.max(0, Math.min(thumb.offsetLeft, maxScroll));
      if (Math.abs(strip.scrollLeft - target) < 1) return;
      if (typeof strip.scrollTo === 'function') {
        strip.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        strip.scrollLeft = target;
      }
    }

    function sync() {
      syncRaf = null;
      var slides = getSlides();
      var activeSlide = getActiveSlide(slides);
      var orderedThumbs = [];
      var visibleCount = 0;

      slides.forEach(function (slide) {
        var thumb = thumbsByKey[slide.dataset.thumbKey];
        if (!thumb) return;
        orderedThumbs.push(thumb);

        var hidden = isSlideHidden(slide);
        thumb.hidden = hidden;
        if (!hidden) visibleCount++;

        var isActive = slide === activeSlide;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      // Mirror slide order (filters move visible slides first). Only touch the DOM when
      // the order actually differs so a focused thumbnail doesn't lose focus.
      var currentThumbs = strip.children;
      var orderChanged = orderedThumbs.some(function (thumb, i) {
        return currentThumbs[i] !== thumb;
      });
      if (orderChanged) {
        orderedThumbs.forEach(function (thumb) {
          strip.appendChild(thumb);
        });
      }

      strip.hidden = visibleCount < 2;

      // Only move the strip when the active media or thumbnail order changes, so a manual
      // scroll of the strip isn't reset by unrelated mutations (lazy-load classes etc.).
      var activeKey = activeSlide ? activeSlide.dataset.thumbKey : null;
      var activeThumb = activeKey ? thumbsByKey[activeKey] : null;
      var activeChanged = activeKey !== lastActiveKey;
      if (activeThumb && !strip.hidden && (activeChanged || orderChanged || forceStripScroll)) {
        scrollThumbToStart(activeThumb, lastActiveKey !== null && activeChanged);
      }
      forceStripScroll = false;
      lastActiveKey = activeKey;
    }

    function scheduleSync() {
      if (syncRaf) return;
      syncRaf = window.requestAnimationFrame(sync);
    }

    // bundle.product.js loads async, so the gallery can be natively scrolled before Swiper
    // initializes. Swiper positions slides with transforms and ignores the container's
    // scrollLeft, which then leaves the main image offset by spaceBetween (8px) and out of
    // sync with the active thumbnail. Convert that scroll offset into a Swiper slide index.
    // Also covers browser focus-scrolling of the overflow-hidden container.
    function normalizeNativeScroll(swiper, isInitialBind) {
      var scrollLeft = swiperEl.scrollLeft;
      if (!scrollLeft) return;
      var slides = getSlides().filter(function (slide) {
        return !isSlideHidden(slide);
      });
      swiperEl.scrollLeft = 0;
      if (!slides.length) return;

      var targetSlide;
      if (isInitialBind) {
        // Pre-init layout: slides had no Swiper margins, so the pitch is the slide width.
        var width = slides[0].offsetWidth || swiperEl.clientWidth || 1;
        targetSlide = slides[Math.round(scrollLeft / width)];
      } else {
        // Swiper active: visible position = current translate + the stray scroll offset.
        var position = -swiper.translate + scrollLeft;
        targetSlide = slides.reduce(function (closest, slide) {
          return Math.abs(slide.offsetLeft - position) < Math.abs(closest.offsetLeft - position) ? slide : closest;
        }, slides[0]);
      }

      var index = targetSlide ? getSlideIndex(swiper, targetSlide) : -1;
      if (index > -1) swiper.slideTo(index, 0);
    }

    function bindSwiper() {
      var swiper = getSwiper();
      if (swiper && swiper !== boundSwiper) {
        boundSwiper = swiper;
        normalizeNativeScroll(swiper, true);
        ['slideChange', 'activeIndexChange', 'slidesLengthChange', 'update', 'resize', 'transitionEnd'].forEach(
          function (eventName) {
            swiper.on(eventName, scheduleSync);
          },
        );
      }
      scheduleSync();
    }

    strip.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb-key]');
      if (!thumb) return;

      var slide = mediaList.querySelector('.product__media-item[data-thumb-key="' + thumb.dataset.thumbKey + '"]');
      if (!slide || isSlideHidden(slide)) return;

      var swiper = getSwiper();
      if (swiper) {
        var index = getSlideIndex(swiper, slide);
        if (index > -1) swiper.slideTo(index);
      } else {
        // Swiper not initialized yet: fall back to native scroll of the pre-init layout.
        swiperEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      scheduleSync();
    });

    // Variant filters toggle slide visibility and reorder slides.
    new MutationObserver(scheduleSync).observe(mediaList, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    // Swiper (re)initialization toggles `swiper-initialized` on the container.
    new MutationObserver(bindSwiper).observe(swiperEl, {
      attributes: true,
      attributeFilter: ['class'],
    });

    swiperEl.addEventListener(
      'scroll',
      function () {
        var swiper = getSwiper();
        if (swiper) {
          normalizeNativeScroll(swiper, false);
        }
        scheduleSync();
      },
      { passive: true },
    );

    // Thumbnail widths depend on the viewport; keep the active one pinned to the start.
    window.addEventListener('resize', function () {
      forceStripScroll = true;
      scheduleSync();
    });

    bindSwiper();
  }

  function init() {
    document.querySelectorAll('[data-pdp-gallery-thumbs]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
